import Commons from '../../../../Services/Common/Common';

export const TRA_CUSTOM_01_Schema = {
  fields: {
    grid: {
      no: { initial: '', label: 'NO' },
      tbmCd: { initial: '', label: 'TBM코드' },
      depNm: { initial: '', label: '부서' },
      affiliationNm: { initial: '', label: '소속' },
      rank: { initial: '', label: '직위' },
      internalYn: { initial: '', label: '회원유형' },
      name: { initial: '', label: '근로자명' },
      tbmAddDate: { initial: '', label: '총 누계시간' },
      achievementRate: { initial: '', label: '달성률(%)' },
    },
    modal: {
      tbmCd: { initial: '', label: 'TBM코드' },
      depNm: { initial: '', label: '부서명' },
      position: { initial: '', label: '직급' },
      name: { initial: '', label: '근로자명' },
      tbmDate: { initial: '', label: '일자' },
      tbmStartDate: { initial: '', label: '시작시간' },
      tbmEndDate: { initial: '', label: '종료시간' },
      tbmAddDate: { initial: '', label: '실시시간(분)' },
      totalTime: { initial: '', label: '누계시간' },
    },
  },

  mapper: {
    search1: {
      Year: (_, context) => Commons.EncryptAES(context.search?.year ?? ''),
      Month: (_, context) => Commons.EncryptAES(context.search?.month ?? ''),
      CustCd: (_, context) => Commons.EncryptAES(context.search?.custCd),
    },
    search2: {
      Year: (_, context) => Commons.EncryptAES(context.search?.year ?? ''),
      Month: (_, context) => Commons.EncryptAES(context.search?.month ?? ''),
      UserId: (_, context) => Commons.EncryptAES(context.userId ?? ''),
    },
    search3: {
      UserId: (_, context) => context.userInfo?.userid || '',
      AuthCd: (_, context) => Commons.EncryptAES(context.userInfo?.authCd || ''),
      CoCd: (_, context) => {
        const coCd =
          context.userInfo?.authCd === 'ADMIN'
            ? context.search?.coCd
            : context.userInfo?.coCd;
        return Commons.EncryptAES(coCd || '');
      },
      CustCd: (_, context) => Commons.EncryptAES(context.search?.custCd || ''),
      SearchText: (_, context) =>
        Commons.EncryptAES(context.search?.searchText || ''),
    },
  },
};
